import { useAccountsWithUnauthenticatedDomains } from 'conversations-inbox-lib/unauthorized-domains/public/hooks';
import { getCurrentInboxId } from 'conversations-inbox-lib/unified-inbox/public/selectors';
import { UnauthenticatedDomainsPrompt } from 'svh-workspace-ui-lib/banners/public/components';
import { useSelector } from 'react-redux';
import { getIsConversationsAdmin } from '../../selectors/userSelectors/getIsConversationsAdmin';
import { getAllConnectedAccounts } from '../../connected-accounts/selectors/getAllConnectedAccounts';
import { getHasEmailSendingDomainAccess } from '../../selectors/userSelectors/getHasEmailSendingDomainAccess';
import { jsx as _jsx } from "react/jsx-runtime";
export function InboxUnauthenticatedDomainsPrompt() {
  const currentInboxId = useSelector(getCurrentInboxId);
  const isConversationsAdmin = useSelector(getIsConversationsAdmin);
  const hasEmailSendingDomainAccess = useSelector(getHasEmailSendingDomainAccess);
  const connectedEmailAccounts = useSelector(getAllConnectedAccounts);
  const connectedEmailAccountsArr =
  // @ts-expect-error connectedEmailAccounts is an ImmutableMap
  connectedEmailAccounts && connectedEmailAccounts.toArray() || null;
  const {
    unauthorizedAccounts
  } = useAccountsWithUnauthenticatedDomains({
    connectedEmailAccounts: connectedEmailAccountsArr
  });
  const canShowPrompt = hasEmailSendingDomainAccess && currentInboxId;
  return canShowPrompt ? /*#__PURE__*/_jsx(UnauthenticatedDomainsPrompt, {
    inboxId: currentInboxId,
    isAdmin: isConversationsAdmin,
    unauthorizedAccounts: unauthorizedAccounts
  }) : null;
}
InboxUnauthenticatedDomainsPrompt.displayName = 'InboxUnauthenticatedDomainsPrompt';